'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactJss = require('react-jss');
var clsx = _interopDefault(require('clsx'));
var mosaicCore = require('@danfoss/mosaic-core');
var mosaic = _interopDefault(require('@danfoss/mosaic-css/dist/mosaic.module.css'));
var mosaicReact = require('@danfoss/mosaic-react');
var tokens = _interopDefault(require('@danfoss/mosaic-themes/dist/web/danfoss-orig/light/tokens.json'));
var DOMPurify = _interopDefault(require('dompurify'));

var sharedStyles = {
  screenReaderOnly: {
    position: 'absolute',
    clip: 'rect(1px 1px 1px 1px)',
    width: 1,
    height: 1,
    overflow: 'hidden'
  }
};

var styles = {
  fieldWrapper: {
    marginBottom: 24
  },
  screenReaderOnly: sharedStyles.screenReaderOnly
};

const useStyles = reactJss.createUseStyles(styles);
const ConsentField = React.memo(({
  label,
  value: isSelected = false,
  disabled,
  setValue,
  error,
  errorMessage,
  controlRef
}) => {
  const labelId = React.useMemo(() => mosaicCore.generateUniqueString('label'), []);
  const inputId = React.useMemo(() => mosaicCore.generateUniqueString('input'), []);
  const classes = useStyles();
  const handleChange = React.useCallback(e => {
    setValue(e.target.checked);
  }, [setValue]);
  return React__default.createElement("div", {
    className: clsx('fs-consent-field-wrapper', mosaic.mosaic, classes.fieldWrapper)
  }, React__default.createElement("div", {
    className: clsx(mosaic.checkbox, {
      disabled: disabled,
      [mosaic.error]: error
    })
  }, React__default.createElement("input", {
    id: inputId,
    ref: controlRef,
    "aria-disabled": disabled,
    "aria-labelledby": labelId,
    type: "checkbox",
    onChange: handleChange,
    checked: isSelected,
    disabled: disabled
  }), React__default.createElement("label", {
    id: labelId,
    htmlFor: inputId
  }, label, error && React__default.createElement("span", {
    className: clsx('fs-screen-reader-only', classes.screenReaderOnly)
  }, errorMessage))), error && React__default.createElement("label", {
    className: clsx('fs-field-error-message', mosaic.helperText, mosaic.error),
    "aria-invalid": true
  }, errorMessage));
});

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

const InfoIcon = props => React__default.createElement("svg", _objectSpread2({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React__default.createElement("path", {
  d: "M7.33334 4.66671H8.66667V6.00004H7.33334V4.66671ZM7.33334 7.33337H8.66667V11.3334H7.33334V7.33337ZM8 1.33337C4.32 1.33337 1.33334 4.32004 1.33334 8.00004C1.33334 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 8 1.33337ZM8 13.3334C5.06 13.3334 2.66667 10.94 2.66667 8.00004C2.66667 5.06004 5.06 2.66671 8 2.66671C10.94 2.66671 13.3333 5.06004 13.3333 8.00004C13.3333 10.94 10.94 13.3334 8 13.3334Z",
  fill: "#303030"
}));

var styles$1 = {
  wrapper: {
    position: 'relative',
    height: 28,
    cursor: 'default'
  },
  label: {
    maxWidth: 'calc(100% - 30px)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  infoIcon: {
    position: 'absolute',
    display: 'inline-block !important',
    top: 3,
    marginLeft: '2px !important',
    paddingTop: 1
  },
  requiredSymbol: {
    color: tokens.TokenColorActiveWeak,
    verticalAlign: 'top'
  },
  disabled: {
    opacity: 0.5
  },
  screenReaderOnly: sharedStyles.screenReaderOnly
};

const useStyles$1 = reactJss.createUseStyles(styles$1);
const Label = React.memo(({
  title,
  required,
  hint,
  disabled,
  id,
  htmlFor,
  errorMessage,
  hasError
}) => {
  const classes = useStyles$1();
  return React__default.createElement("div", {
    className: clsx('fs-label-wrapper', mosaic.mosaic, classes.wrapper)
  }, React__default.createElement("label", {
    id: id,
    htmlFor: htmlFor,
    className: clsx('fs-label', mosaic.fieldLabel, classes.label, {
      disabled: disabled,
      [classes.disabled]: disabled
    }),
    "aria-hidden": disabled
  }, title, React__default.createElement("span", {
    "aria-hidden": disabled,
    className: clsx('fs-required-symbol', classes.requiredSymbol)
  }, title && required ? ' *' : null, "\u00A0"), hasError && errorMessage && React__default.createElement("span", {
    className: clsx('fs-screen-reader-only', classes.screenReaderOnly)
  }, errorMessage), hint && React__default.createElement("span", {
    className: clsx('fs-screen-reader-only', classes.screenReaderOnly)
  }, hint)), hint && React__default.createElement(mosaicReact.DfTooltip, {
    disabled: disabled,
    arrowOffset: -1
  }, React__default.createElement("span", {
    slot: "tooltip-reference",
    className: clsx(mosaic.ml1, mosaic.icon, classes.infoIcon, {
      [classes.disabled]: disabled
    }),
    "aria-label": `${title} info icon`
  }, React__default.createElement(InfoIcon, null)), React__default.createElement("span", {
    slot: "tooltip-content"
  }, hint)));
});

var styles$2 = {
  selectWrapper: {
    marginBottom: 12
  },
  fieldError: {
    marginBottom: 0
  }
};

const useStyles$2 = reactJss.createUseStyles(styles$2);
const getOptionLabelUtil = o => o.title;
const DropdownField = React.memo(({
  name,
  placeholder,
  label,
  options,
  hint,
  setValue,
  value = '',
  error,
  errorMessage,
  disabled,
  required,
  controlRef,
  isLoading,
  isSearchable = false
}) => {
  const classes = useStyles$2();
  const labelId = React.useMemo(() => mosaicCore.generateUniqueString('label'), []);
  const inputId = React.useMemo(() => mosaicCore.generateUniqueString('input'), []);
  const handleOnChange = React.useCallback(e => {
    setValue(e.detail.value.value);
  }, [setValue]);
  const selectValue = React.useMemo(() => {
    var _options$find;
    return (_options$find = options.find(o => o.value === value)) !== null && _options$find !== void 0 ? _options$find : [];
  }, [options, value]);
  return React__default.createElement("div", {
    className: clsx('fs-dropdown-field-wrapper', mosaic.mosaic, mosaic.formField)
  }, label ? React__default.createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    title: label,
    errorMessage: errorMessage,
    hasError: error,
    required: required,
    disabled: disabled,
    hint: hint
  }) : null, React__default.createElement("div", {
    className: clsx('fs-select-wrapper', classes.selectWrapper, {
      'fs-field-error': error,
      [classes.fieldError]: error,
      disabled: disabled
    })
  }, React__default.createElement("div", {
    className: clsx('fs-form-control'),
    "aria-haspopup": "listbox"
  }, React__default.createElement(mosaicReact.DfSelect, {
    ref: controlRef,
    inputId: inputId,
    errorType: error ? 'error' : undefined,
    "aria-labelledby": labelId,
    options: options,
    name: name,
    disabled: disabled || isLoading,
    getOptionLabel: getOptionLabelUtil,
    isSearchable: isSearchable,
    "aria-disabled": disabled,
    onSelectChange: handleOnChange,
    placeholder: placeholder,
    value: selectValue,
    isLoading: isLoading,
    noOptionsMessage: ""
  })), error && React__default.createElement("label", {
    className: clsx('fs-field-error-message', mosaic.helperText, mosaic.error),
    "aria-invalid": true
  }, errorMessage, "\u00A0")));
});

const LinkButton = React.memo(({
  label,
  url,
  newWindow = false,
  onClick
}) => React__default.createElement("div", {
  className: clsx(mosaic.mosaic)
}, React__default.createElement("a", {
  className: clsx('fs-link-button', mosaic.btnPrimary),
  href: url,
  target: newWindow ? '_blank' : null,
  onClick: onClick,
  rel: "noreferrer"
}, label)));

var styles$3 = {
  wrapper: {
    marginBottom: 12,
    letterSpacing: '.01em',
    '& a': {
      fontWeight: 400
    },
    '& a:hover, & a:focus': {
      color: tokens.TokenColorError
    },
    '& a, & a:focus, & a:visited': {
      textDecoration: 'underline'
    },
    '& p': {
      margin: 0
    }
  },
  disabled: {
    opacity: 0.5
  }
};

const useStyles$3 = reactJss.createUseStyles(styles$3);
const PlainText = React.memo(({
  label,
  disabled
}) => {
  const classes = useStyles$3();
  return React__default.createElement("div", {
    className: clsx('fs-text-wrapper', mosaic.mosaic, classes.wrapper, {
      disabled: disabled,
      [classes.disabled]: disabled
    }),
    "aria-hidden": disabled,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(label, {
        ADD_ATTR: ['target']
      })
    }
  });
});

var styles$4 = {
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

const useStyles$4 = reactJss.createUseStyles(styles$4);
const SubmitButton = React.memo(({
  label,
  processingLabel,
  disabled,
  isFormSubmitting
}) => {
  const classes = useStyles$4();
  return React__default.createElement("div", {
    className: clsx(mosaic.mosaic)
  }, React__default.createElement("button", {
    className: clsx(mosaic.btnPrimary, {
      [mosaic.loading]: isFormSubmitting
    }),
    disabled: disabled,
    "aria-hidden": disabled,
    type: "submit"
  }, React__default.createElement("span", {
    className: clsx('fs-submit-button-content', classes.buttonContent)
  }, isFormSubmitting && React__default.createElement("span", {
    className: clsx(mosaic.icon)
  }, React__default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M16 9C16 9.55229 16.4477 10 17 10C17.5523 10 18 9.55229 18 9H16ZM9 18C9.55229 18 10 17.5523 10 17C10 16.4477 9.55229 16 9 16V18ZM9 16C5.13401 16 2 12.866 2 9H0C0 13.9706 4.02944 18 9 18V16ZM2 9C2 5.13401 5.13401 2 9 2V0C4.02944 0 0 4.02944 0 9H2ZM9 2C12.866 2 16 5.13401 16 9H18C18 4.02944 13.9706 0 9 0V2Z",
    fill: "currentColor"
  }))), React__default.createElement("span", {
    className: "fs-submit-button-text"
  }, isFormSubmitting ? processingLabel : label))));
});

var styles$5 = {
  textareaWrapper: {
    marginBottom: 12
  },
  textareaError: {
    marginBottom: 0
  }
};

const useStyles$5 = reactJss.createUseStyles(styles$5);
const TextAreaField = React.memo(({
  name,
  placeholder,
  hint,
  label,
  value,
  error,
  errorMessage,
  setValue,
  required,
  disabled,
  controlRef,
  beforeFieldText,
  afterFieldText
}) => {
  const classes = useStyles$5();
  const labelId = React.useMemo(() => mosaicCore.generateUniqueString('label'), []);
  const inputId = React.useMemo(() => mosaicCore.generateUniqueString('input'), []);
  return React__default.createElement("div", {
    className: clsx('fs-textarea-field-wrapper', mosaic.mosaic, mosaic.formField)
  }, Boolean(beforeFieldText) && React__default.createElement("div", {
    className: clsx(mosaic.mb2)
  }, beforeFieldText), Boolean(label) && React__default.createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    title: label,
    errorMessage: errorMessage,
    hasError: error,
    required: required,
    disabled: disabled,
    hint: hint
  }), React__default.createElement("div", {
    className: clsx('fs-textarea-wrapper', classes.textareaWrapper, {
      disabled: disabled,
      'fs-textarea-error': error,
      [classes.textareaError]: error
    })
  }, React__default.createElement("textarea", {
    id: inputId,
    ref: controlRef,
    className: clsx(mosaic.textarea, {
      disabled: disabled,
      [mosaic.error]: error
    }),
    placeholder: placeholder,
    name: name,
    onChange: e => setValue(e.target.value),
    value: value,
    disabled: disabled,
    "aria-labelledby": labelId,
    "aria-disabled": disabled,
    "aria-invalid": error,
    rows: 4
  }), error && React__default.createElement("label", {
    className: clsx('fs-field-error-message', mosaic.helperText, mosaic.error),
    "aria-invalid": true
  }, errorMessage, "\u00A0")), Boolean(afterFieldText) && React__default.createElement("div", {
    className: clsx(mosaic.mb2)
  }, afterFieldText));
});

var styles$6 = {
  inputWrapper: {
    marginBottom: 12
  },
  inputError: {
    marginBottom: 0
  }
};

const useStyles$6 = reactJss.createUseStyles(styles$6);
const TextField = React.memo(({
  name,
  placeholder,
  hint,
  setValue,
  label,
  required,
  disabled,
  error,
  errorMessage,
  value = '',
  type,
  controlRef
}) => {
  const classes = useStyles$6();
  const labelId = React.useMemo(() => mosaicCore.generateUniqueString('label'), []);
  const inputId = React.useMemo(() => mosaicCore.generateUniqueString('input'), []);
  const handleChange = React.useCallback(e => {
    setValue(e.target.value);
  }, [setValue]);
  return React__default.createElement("div", {
    className: clsx('fs-input-field-wrapper', mosaic.mosaic, mosaic.formField)
  }, Boolean(label) && React__default.createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    title: label,
    errorMessage: errorMessage,
    hasError: error,
    required: required,
    disabled: disabled,
    hint: hint
  }), React__default.createElement("div", {
    className: clsx('fs-input-wrapper', classes.inputWrapper, {
      'fs-input-error': error,
      [classes.inputError]: error,
      disabled: disabled
    })
  }, React__default.createElement("input", {
    id: inputId,
    ref: controlRef,
    type: type === 'Phone' ? 'tel' : null,
    className: clsx('fs-form-control', mosaic.input, {
      disabled: disabled,
      [mosaic.error]: error
    }),
    placeholder: placeholder,
    name: name,
    onChange: handleChange,
    value: value,
    disabled: disabled,
    "aria-required": required,
    "aria-labelledby": labelId,
    "aria-disabled": disabled
  }), error && React__default.createElement("label", {
    className: clsx('fs-field-error-message', mosaic.helperText, mosaic.error),
    "aria-invalid": true
  }, errorMessage, "\u00A0")));
});

const fieldComponentMap = {
  Text: TextField,
  Dropdown: DropdownField,
  Phone: TextField,
  TextArea: TextAreaField,
  Consent: ConsentField,
  Submit: SubmitButton,
  LinkButton: LinkButton,
  PlainText: PlainText
};

exports.fieldComponentMap = fieldComponentMap;
//# sourceMappingURL=index.js.map
